import React from 'react';
import Rater from 'react-rater';
import { Grid, Text } from 'elements';
import { Button } from 'antd';
import { RightOutlined } from '@ant-design/icons';
import { Colors, SecondaryColor, PrimaryColor } from 'GlobalStyles';
import DefaultUser from 'assets/icons/default.webp';

interface ICard {
  type?: string;
  thumbnail?: string;
  thumbnailTitle?: string;
  name: string;
  subTitle?: string;
  rateCount?: number;
  rate?: number;
  rateTitle?: string;
  career?: React.ReactNode;
  questions?: Array<string>;
  price?: string;
  isPurchase?: boolean;
  onClick?: () => void;
}

const Card = ({
  type = 'normal',
  thumbnail,
  thumbnailTitle,
  name,
  subTitle,
  rateCount,
  rate,
  rateTitle,
  career,
  questions,
  price,
  isPurchase,
  onClick,
}: ICard) => {
  if (type === 'normal') {
    return (
      <Grid
        isInline
        position='relative'
        border={`1px solid ${Colors.grey1}`}
        borderRadius='4px'
        overflow='hidden'
        md={{ maxWidth: '528px' }}
        align='space-between'
      >
        {!!price && (
          <Grid position='relative' backgroundColor={Colors.background} padding='8px 16px' gap='5px'>
            <Text>가격:</Text>
            <Text>{price}</Text>

            <Grid></Grid>
          </Grid>
        )}
        {isPurchase && (
          // <div> 하하</div>
          <>
            <Grid
              isInline
              position='absolute'
              width='100px'
              height='100px'
              backgroundColor='#B1DFB3'
              style={{ transform: 'rotate(45deg)', right: -50, top: -50 }}
            />
            <Grid isInline position='absolute' style={{ right: 5, top: 5 }}>
              <Text color={Colors.white} bold>
                구매됨
              </Text>
            </Grid>
          </>
        )}
        <Grid md={{ gap: '10px', isNoWrap: true }} sm={{ isNoWrap: false }}>
          <Grid padding='24px 16px 16px 16px' md={{ isInline: true, width: '45%' }} sm={{ width: '100%' }}>
            <Grid justify='center'>
              <Grid
                isInline
                image={thumbnail || DefaultUser}
                width='130px'
                height='130px'
                borderRadius='130px'
                justify='center'
                align='flex-end'
              >
                {!!thumbnailTitle && (
                  // <Grid position='relative' isInline padding='2px 8px' borderRadius='4px'
                  //   backgroundColor={SecondaryColor} border={`3px solid ${Colors.white}`} style={{ bottom: -10 }}>
                  <Grid
                    position='relative'
                    isInline
                    padding='2px 8px'
                    borderRadius='4px'
                    backgroundColor={thumbnailTitle === '시니어' ? PrimaryColor : SecondaryColor}
                    border={`3px solid ${Colors.white}`}
                    style={{ bottom: -10 }}
                  >
                    <Text color={Colors.white}>{thumbnailTitle}</Text>
                  </Grid>
                )}
              </Grid>
            </Grid>
            <Grid justify='center' marginTop='15px'>
              <Text bold size='1.8rem'>
                {name}
              </Text>
            </Grid>
            {!!subTitle && (
              <Grid justify='center'>
                <Text size='1.1rem' color={Colors.grey3}>
                  {subTitle}
                </Text>
              </Grid>
            )}
            {!!rateCount && (
              <Grid justify='space-between' isNoWrap align='center'>
                <Grid isInline width='25%' align='center'>
                  <Text size='0.9rem'>평점 ({rateCount})</Text>
                </Grid>
                <Grid isInline justify='center' align='center'>
                  <Grid justify='center'>
                    <Rater total={6} rating={rate} interactive={false} />
                  </Grid>
                  <Grid justify='center'>
                    <Text size='1.1rem' bold>
                      {rateTitle}
                    </Text>
                  </Grid>
                </Grid>
                <Grid isInline width='25%' />
              </Grid>
            )}
          </Grid>
          <Grid md={{ isInline: true, width: '55%' }} sm={{ width: '100%' }}>
            {!!career && (
              <Grid padding='8px 16px' style={{ borderTop: `1px solid ${Colors.grey0}` }}>
                {career}
              </Grid>
            )}
            {!!questions && questions.length > 0 && (
              <Grid padding='8px 16px' style={{ borderTop: `1px solid ${Colors.grey0}` }}>
                <Grid>Key Questions:</Grid>
                {questions.map((question, index) => (
                  <Grid gap='5px' isNoWrap key={index}>
                    <Text>∙</Text>
                    <Text>{question}</Text>
                  </Grid>
                ))}
              </Grid>
            )}
          </Grid>
        </Grid>
        {!!onClick && (
          <Button
            style={{
              width: '100%',
              padding: '8px 16px !impotant',
              backgroundColor: `${Colors.background} !important`,
            }}
            onClick={onClick}
          >
            <Grid justify='space-between' align='center'>
              <Text>{name} 멘토의 해설 보기</Text>
              <RightOutlined />
            </Grid>
          </Button>
        )}
      </Grid>
    );
  } else {
    return (
      <Grid
        border={`1px solid ${Colors.grey1}`}
        borderRadius='4px'
        overflow='hidden'
        gap='20px'
        justify='space-between'
        padding='24px 8%'
      >
        <Grid isInline width='130px'>
          <Grid
            isInline
            image={thumbnail}
            width='130px'
            height='130px'
            borderRadius='130px'
            justify='center'
            align='flex-end'
          >
            {!!thumbnailTitle && (
              // <Grid position='relative' isInline padding='2px 8px' borderRadius='4px'
              //   backgroundColor={SecondaryColor} border={`3px solid ${Colors.white}`} style={{ bottom: -10 }}>
              <Grid
                position='relative'
                isInline
                padding='2px 8px'
                borderRadius='4px'
                backgroundColor={thumbnailTitle === '시니어' ? PrimaryColor : SecondaryColor}
                border={`3px solid ${Colors.white}`}
                style={{ bottom: -10 }}
              >
                <Text color={Colors.white}>{thumbnailTitle}</Text>
              </Grid>
            )}
          </Grid>
        </Grid>
        <Grid isInline width='calc(100% - 150px)'>
          <Grid align='center' gap='40px'>
            <Text bold size='1.8rem'>
              {name}
            </Text>
            {!!subTitle && (
              <Grid maxWidth='50%'>
                <Text ellipsis={1} size='1.1rem' color={Colors.grey3}>
                  {subTitle}
                </Text>
              </Grid>
            )}
          </Grid>
          {!!career && (
            <Grid padding='4px 0' style={{ borderTop: `1px solid ${Colors.grey0}` }}>
              {career}
            </Grid>
          )}
          {!!rateCount && (
            <Grid
              justify='space-around'
              isNoWrap
              style={{ borderTop: `1px solid ${Colors.grey0}` }}
              padding='4px 0'
            >
              <Grid isInline width='25%' align='center'>
                <Text size='0.9rem'>평점 ({rateCount})</Text>
              </Grid>
              <Grid isInline justify='center' align='center'>
                <Grid justify='center'>
                  <Rater total={6} rating={rate} interactive={false} />
                </Grid>
                {/* 여기의 별점 타이틀은 리로드 됐을 때 반영??? */}
                <Grid justify='center'>
                  <Text size='1.1rem' bold>
                    {rateTitle}
                  </Text>
                </Grid>
              </Grid>
            </Grid>
          )}
        </Grid>
      </Grid>
    );
  }
};

export default Card;
